var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 24 / calendar_today"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07688 17.3459H10.1192C11.3868 17.3459 11.8093 16.9586 11.8093 15.691V13.6135C11.8093 12.3811 11.3868 11.9938 10.1192 11.9938H8.07688C6.80926 11.9938 6.38672 12.3811 6.38672 13.6135V15.691C6.38672 16.9586 6.80926 17.3459 8.07688 17.3459Z",
    fill: "#333333",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0469 20.2268H5.94434C4.0459 20.2268 3.05273 19.2424 3.05273 17.3616V6.66528C3.05273 4.77563 4.0459 3.80005 5.94434 3.80005H18.0469C19.9541 3.80005 20.9473 4.78442 20.9473 6.66528V17.3616C20.9473 19.2424 19.9541 20.2268 18.0469 20.2268ZM4.80176 17.3264C4.80176 18.0999 5.20605 18.4778 5.93555 18.4778H18.0557C18.7852 18.4778 19.1895 18.0999 19.1895 17.3264V9.24048C19.1895 8.46704 18.7852 8.08911 18.0557 8.08911H5.93555C5.20605 8.08911 4.80176 8.46704 4.80176 9.24048V17.3264Z",
    fill: "#333333",
    fillOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.ef60e5a9e19fbb107225780665ca7008.svg";
export { ForwardRef as ReactComponent };